/* eslint-disable max-len */
import React from 'react';

var IconEdit = function IconEdit() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "25",
    height: "25",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h25v25H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#444749",
    strokeWidth: "1.5",
    d: "M5 20v-3l9-9 3 3-9 9zM16 6l3 3 1.5-1.5-3-3z"
  })));
};

export default IconEdit;